// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/common.less
// module id = KhYh
// module chunks = 1